import { ArticleReactionOptions } from "@elements/Reactions/ArticleReactionOptions";
import { ArticleReactions } from "@elements/Reactions/ArticleReactions";
import { isArrayWithElements } from "@helper/utils";
import { HandleReactionClick, ReactionProp } from "@typings/Reactions.d";
import { forwardRef, type ReactElement, useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

export type ReactionToolbarProps = {
  articleId: string;
  showReactions?: boolean;
  reactions: ReactionProp[];
  userReactions: string;
  reactionsError: Error | null;
  handleReactionClick: HandleReactionClick;
  expandStyle?: string;
  qnStyle?: boolean;
};

const ReactionToolbar = forwardRef<HTMLDivElement, ReactionToolbarProps>(
  function ReactionToolbar(
    {
      articleId,
      reactions,
      userReactions,
      reactionsError,
      handleReactionClick,
      showReactions = false,
      expandStyle = "",
      qnStyle = false,
    }: ReactionToolbarProps,
    ref,
  ): ReactElement {
    const [isReactionExpanded, setIsReactionExpanded] = useState(false);

    if (!isArrayWithElements(reactions)) {
      showReactions = false;
    }

    useEffect(() => {
      const handleOutsideClick = (event: MouseEvent | TouchEvent) => {
        const el = event.target as HTMLElement;
        if (
          !(
            el.classList.contains("interaction-toolbar") ||
            el.closest(".interaction-toolbar")
          )
        ) {
          setIsReactionExpanded(false);
        }
      };

      globalThis.addEventListener("mouseup", handleOutsideClick);
      globalThis.addEventListener("touchend", handleOutsideClick);

      return () => {
        globalThis.removeEventListener("mouseup", handleOutsideClick);
        globalThis.addEventListener("touchend", handleOutsideClick);
      };
    }, []);

    return (
      <div className="interaction-toolbar flex" ref={ref}>
        <div className="relative flex gap-x-md md:gap-x-lg">
          {showReactions && !reactionsError && (
            <>
              <div className="items-center">
                <button
                  className="flex items-center gap-x-sm"
                  onClick={() => {
                    setIsReactionExpanded(!isReactionExpanded);
                  }}
                >
                  <ArticleReactions
                    reactions={reactions}
                    reactionsUser={userReactions}
                    referer={`article-${articleId}`}
                    qnStyle={qnStyle}
                  />
                </button>
              </div>
              {isReactionExpanded && (
                <div
                  className={twMerge(
                    "absolute z-10",
                    expandStyle || "top-12 left-0 lg:-left-20",
                  )}
                >
                  <ArticleReactionOptions
                    reactions={reactions}
                    handleReactionClick={handleReactionClick}
                    reactionsUser={userReactions}
                    articleId={articleId}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  },
);

export default ReactionToolbar;
